import { render } from "./ExplCards.vue?vue&type=template&id=bde5645c&scoped=true"
import script from "./ExplCards.vue?vue&type=script&lang=js"
export * from "./ExplCards.vue?vue&type=script&lang=js"

import "./ExplCards.vue?vue&type=style&index=0&id=bde5645c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde5645c"]])

export default __exports__